import {
  loginRequest,
  postJsonRequest,
  getRequest
} from "@/utils/api";
import {uri} from "@/api/uri/archiveUri/user";
import StorageHelp from "@/utils/storageHelp";
import Toast from '@/utils/toast'
import Session from '@/utils/Session'
import store from '@/store'
//前端区分
export const USER_TYPE = {
  CUSTOMER: 3,//普通用户
  WORKER: 4,//工作人员
};


/**
 * 通過卡号 获取个人信息
 * @param cardNumber
 * @return {Promise<any>}
 */

export function getSysUserByDPCMemberInfoCardNum(cardNumber) {
  return new Promise((resolve, reject) => {
    getRequest(uri.user.getSysUser + cardNumber, {}, {middleware: true, rootData: true}).then(resp => {
      resolve(resp);
    }).catch(err => {
      Toast.show({
        title: err,
        icon: 'error'
      });
      reject(err)
    });
  });

}

/**
 * 获取当前管理员的菜单
 * @param params
 * @returns {Promise}
 */

export function getSysMenu() {
  return new Promise((resolve, reject) => {
    getRequest(uri.user.getUserMenu, {}, {middleware: true, rootData: true}).then(resp => {
      resolve(resp.data.data)
    }).catch(error => {
      Toast.show({
        message: error || '获取菜单权限失败',
        type: 'error'
      });
      reject(error)
    })
  })
}




// WEBPACK FOOTER //
// ./src/api/archiveManage/user.js